// X95 (R36 H1): the ONE row builder both booking grids use (the admin calendar's calendarGrid in utils/bookings.js and
// the member /book page's dayRows in utils/bookingWeek.js), so their rows can't drift apart again. The rows ARE the API's
// slots: every slot start and end is a row boundary, and only between two boundaries do rows run on the step (a gap
// between slots, which both grids draw as open play, or a longer slot of another group on a shared axis), the last one
// cut short at the next boundary. A slot at 14:30 on a 40-minute set gives rows 14:30, 15:10, …, never a made-up 14:40.
// Unit-free: the admin calendar passes epoch ms, /book minutes from midnight.

/**
 * Slots → contiguous grid rows.
 *   slotRows([{start, end}], step) → [{start, end}] sorted, each row ending where the next starts (the last at the
 *   latest slot end). Empty input gives [].
 */
export function slotRows(slots, step) {
  const list = (slots ?? []).filter((s) => Number.isFinite(s?.start) && Number.isFinite(s?.end) && s.end > s.start);
  if (!list.length) return [];
  const s = Math.max(1, Number(step) || 1);
  const bounds = [...new Set(list.flatMap((x) => [x.start, x.end]))].sort((a, b) => a - b);
  const last = bounds[bounds.length - 1];
  const starts = new Set();
  for (let i = 0; i + 1 < bounds.length; i++) for (let t = bounds[i]; t < bounds[i + 1]; t += s) starts.add(t);
  const times = [...starts].sort((a, b) => a - b);
  return times.map((t, i) => ({start: t, end: times[i + 1] ?? last}));
}
